import React from 'react';
import './AddMedForm.css';
import CloseIcon from '@mui/icons-material/Close';

type AddCotutorFormProps = {
  email: string;
  handleEmailChange: (email: string) => void;
  sendEmail: () => void;
  closeForm: () => void;
};

function AddCotutorForm({ email, handleEmailChange, sendEmail, closeForm }: AddCotutorFormProps) {
  return (
    <div className="add-cotutor-form">
      <div className="row-auto">
        <ul
          className="nav nav-pills nav-fill"
          style={{ display: 'flex', flexDirection: 'row-reverse', marginLeft: '2vw' }}
        >
          <button className="closeFormbutton-cotutor" onClick={closeForm}>
            <CloseIcon />
          </button>
        </ul>
        <div className="col-auto">
          <div className="row">
            <h4>Ingrese el correo del Cotutor/a</h4>
          </div>
          <div className="spacer12"></div>
          <input
            type="email"
            className="email-input"
            placeholder="Ingrese el correo del Cotutor/a"
            value={email}
            onChange={(e) => handleEmailChange(e.target.value)}
          />
          <div className="spacer20"></div>
          <div className="center-button">
            <button onClick={sendEmail} className="cotutor-form-button">
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCotutorForm;
